// extracted by mini-css-extract-plugin
export default {"wrapper":"MyDetailSurvey_wrapper__lHwyP","info-ques":"MyDetailSurvey_info-ques__8pBkH","Breadcumb":"MyDetailSurvey_Breadcumb__Rm7F2","title":"MyDetailSurvey_title__kkE0G"};